import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 text-center tw-text-[20px]" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Select an option...")
], -1)

import Tabs from '@/components/Tabs/index.vue';
  import Tab from '@/components/Tabs/Tab.vue';
  import MLOTables from '../../Tables/MLOTables.vue';
  import ForeignTables from '../../Tables/ForeignTables.vue';
  import { ref } from 'vue';
  import UserService from "@/shared/services/user.service";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'RealtorMLO',
  setup(__props) {

  
  const userSession = ref(null)
  
  const getSession = () => {
    let session =
      localStorage.getItem("usersession") &&
        localStorage.getItem("usersession").length > 0
        ? JSON.parse(localStorage.getItem("usersession"))
        : null;
  
    if (session) {
      userSession.value = session;
    } else {
      UserService.logout("Session expired!");
    }
  }
  getSession();
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(Tabs, { id: "realtorMLO" }, {
      default: _withCtx(() => [
        _createVNode(Tab, {
          title: "PRIMARY",
          "is-active": true
        }, {
          default: _withCtx(() => [
            _createVNode(MLOTables, {
              userID: userSession.value.iduser,
              type: "primary",
              realtorMLO: true
            }, null, 8, ["userID"])
          ]),
          _: 1
        }),
        _createVNode(Tab, { title: "SECOND" }, {
          default: _withCtx(() => [
            _createVNode(MLOTables, {
              userID: userSession.value.iduser,
              type: "second",
              realtorMLO: true
            }, null, 8, ["userID"])
          ]),
          _: 1
        }),
        _createVNode(Tab, { title: "INVESTMENT" }, {
          default: _withCtx(() => [
            _createVNode(MLOTables, {
              userID: userSession.value.iduser,
              type: "investment",
              realtorMLO: true
            }, null, 8, ["userID"])
          ]),
          _: 1
        }),
        _createVNode(Tab, { title: "SPECIAL" }, {
          default: _withCtx(() => [
            _createVNode(MLOTables, {
              userID: userSession.value.iduser,
              type: "special-program",
              specialProgram: true,
              realtorMLO: true
            }, null, 8, ["userID"])
          ]),
          _: 1
        }),
        _createVNode(Tab, { title: "FOREIGN" }, {
          default: _withCtx(() => [
            _createVNode(ForeignTables, {
              userID: userSession.value.iduser
            }, null, 8, ["userID"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})